import { Box, Skeleton } from '@mui/material';
import { School, useGetPrivateImage } from '@schooly/api';
import React from 'react';

export interface SchoolAvatarProps {
  school: School;
  lightSkeleton?: boolean;
}

export const SchoolAvatar: React.FC<SchoolAvatarProps> = ({ school, lightSkeleton }) => {
  const imageUrl = school?.image;
  const { data: image, isFetching } = useGetPrivateImage(imageUrl);
  const isLoading = !!imageUrl && isFetching;

  return isLoading ? (
    <Skeleton
      variant="circular"
      sx={{ background: (theme) => (lightSkeleton ? theme.palette.common.lightBg : undefined) }}
    />
  ) : (
    <Box
      className="avatar"
      sx={{
        width: '100%',
        height: '100%',
        background: `center / contain no-repeat url(${image}) #fff`,
      }}
    />
  );
};
